import React from 'react';

export const ReviewItem = () => {
  return (
    <div className="review-item">
      <p className="review-text">
        "I don't usually write reviews, but this product is
        too good to keep to myself. It's like the secret
        sauce to my happiness."
      </p>
      <div className="reviewer-profile-wrapper">
        <div className="reviewer-proflio-div">
          <div className="user-image">
            <img
              src="/images/pexels-askar-abayev-6190661-1.jpg"
              loading="lazy"
              sizes="(max-width: 1024px) 100vw, 1024px"
              srcSet="/images/pexels-askar-abayev-6190661-1-p-500.jpeg 500w, /images/pexels-askar-abayev-6190661-1-p-800.jpeg 800w, /images/pexels-askar-abayev-6190661-1.jpg 1024w"
              alt=""
              className="user-image-file"
            />
          </div>
          <div className="reviewer">This is some </div>
        </div>
        <div className="star-container">
          {[1, 2, 3, 4, 5].map((star) => (
            <div key={star} className="star-wrapper">
              <div className="review-star w-embed">
                <svg
                  width={420}
                  height={420}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.0002 17L6.12223 20.59L7.72023 13.89L2.49023 9.41L9.35523 8.86L12.0002 2.5L14.6452 8.86L21.5112 9.41L16.2802 13.89L17.8782 20.59L12.0002 17Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
